import { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from '~/i18n'

const Hidden = styled.div`
  display: ${props => props.show ? 'block' : 'none'};
`
const More = styled.p`
  display: ${props => props.show ? 'block' : 'none'};
  text-decoration: underline;
  color: #0055ff;
  cursor: pointer;
`
const BlockQuote = styled.div`
  padding: 1rem;
  border-width: 3px;
  border-style: solid;
  border-image: 
  linear-gradient(
      to bottom, 
      #0055ff, 
      rgba(0, 0, 0, 0)
  ) 1 100%;
`
const OurStory = () => {
  const [t] = useTranslation()
  const [show, seeMore] = useState(false)
  return (
    <BlockQuote className='col-md-10'>
      <p className=''>{t`OUR STORY 0`}</p>
      <p className=''>{t`OUR STORY 1`}</p>
      <More show={!show} onClick={() => seeMore({show: true})}>{t`Xem thêm`} &gt;</More>
      <Hidden show={show}>
        <p>{t`OUR STORY 2`}</p>
        <p>{t`OUR STORY 3`}</p>
        <p>{t`OUR STORY 4`}</p>
        <p>{t`OUR STORY 5`}</p>
        <p>{t`OUR STORY 6`}</p>
        <p>{t`OUR STORY 7`}</p>
        <p>{t`OUR STORY 8`}</p>
      </Hidden>
    </BlockQuote>
  )
}
export default OurStory
